
document.addEventListener('DOMContentLoaded', () => {

    const rawCorePlusConditions=[{condition:"Cystic fibrosis",gene:"CFTR",inheritance:"AR",carrierFreq:"1 in 32",detectionRate:"99%"},{condition:"Spinal muscular atrophy (incl. silent carrier)",gene:"SMN1",inheritance:"AR",carrierFreq:"1 in 54",detectionRate:"91%"},{condition:"Fragile X syndrome premutation",gene:"FMR1",inheritance:"XL",carrierFreq:"1 in 259",detectionRate:"99%"}];
    const rawCouplesConditions = (document.getElementById('cpv-source-couples')?.textContent || '').trim().split('\n').filter(Boolean).map((line) => { const i = line.indexOf(','); return { condition: line.slice(i + 1), gene: line.slice(0, i) }; });
    const allConditionsRaw = (document.getElementById('cpv-source-comprehensive')?.textContent || '').trim();

const state = {
  activeTab: "comprehensive",
  searchTerm: "",
  viewMode: "table",
  tableExpanded: false,
  openCategories: {
    comprehensive: new Set(),
    couples: new Set(),
    coreplus: new Set(),
  },
};

const categoryDescriptions = {
  "Metabolic":
    "Conditions that affect how the body turns food into energy or clears cellular waste.",
  "Intellectual & other impacts":
    "Conditions that affect intellect/ability to learn and have other health impacts.",
  "Bone & muscle":
    "Conditions that affect bone formation or development, or nerves that control muscle function.",
  "Neurological":
    "Conditions that affect the function of the central nervous system, including the brain.",
  "Immune & blood":
    "Conditions that affect the immune system or affect the blood, including bone marrow, red/white blood cells.",
  "Single organ":
    "Conditions that affect a single major body system (e.g. cardiovascular, gastrointestinal systems).",
  "Other, rare":
    "Conditions that impact different areas of health/body that occur together, but does not affect intellect.",
};

const categoryColors = {
  "Metabolic": "var(--cpv-cat-metabolic)",
  "Intellectual & other impacts": "var(--cpv-cat-intellectual)",
  "Bone & muscle": "var(--cpv-cat-bone)",
  "Neurological": "var(--cpv-cat-neurological)",
  "Immune & blood": "var(--cpv-cat-immune)",
  "Single organ": "var(--cpv-cat-single-organ)",
  "Other, rare": "var(--cpv-cat-other)",
};

const legendCategoryOrder = [
  "Metabolic",
  "Intellectual & other impacts",
  "Bone & muscle",
  "Neurological",
  "Immune & blood",
  "Single organ",
  "Other, rare",
];

const isMobile = () => window.matchMedia("(max-width: 767px)").matches;

const categorizeCondition = (conditionName) => {
  const name = conditionName.toLowerCase();
  if (
    (name.includes("deficiency") &&
      (name.includes("dehydrogenase") || name.includes("synthetase"))) ||
    name.includes("aciduria") ||
    name.includes("acidemia") ||
    name.includes("metabolic") ||
    name.includes("glycogen storage") ||
    name.includes("galactosemia") ||
    name.includes("phenylketonuria") ||
    name.includes("tyrosinemia") ||
    name.includes("maple syrup") ||
    name.includes("homocystinuria") ||
    name.includes("methylmalonic") ||
    name.includes("propionic") ||
    name.includes("isovaleric") ||
    name.includes("glutaric") ||
    name.includes("biotinidase") ||
    name.includes("carnitine") ||
    name.includes("fatty acid") ||
    name.includes("pyruvate") ||
    name.includes("fructose") ||
    name.includes("galactokinase") ||
    name.includes("pompe") ||
    name.includes("gaucher") ||
    name.includes("tay-sachs") ||
    name.includes("sandhoff") ||
    name.includes("krabbe") ||
    name.includes("metachromatic") ||
    name.includes("mucopolysaccharidosis") ||
    name.includes("niemann-pick") ||
    name.includes("wilson") ||
    name.includes("hemochromatosis") ||
    name.includes("glycosylation") ||
    name.includes("peroxisomal") ||
    name.includes("mitochondrial") ||
    name.includes("adrenoleukodystrophy")
  )
    return "Metabolic";

  if (
    name.includes("ataxia") ||
    name.includes("spastic") ||
    name.includes("cerebellar") ||
    name.includes("leukodystrophy") ||
    name.includes("encephalopathy") ||
    name.includes("epilepsy") ||
    name.includes("seizure") ||
    name.includes("neuronal ceroid") ||
    name.includes("leigh syndrome") ||
    name.includes("canavan") ||
    name.includes("neurodegeneration") ||
    name.includes("pontocerebellar") ||
    name.includes("microcephaly") ||
    name.includes("neuropathy") ||
    name.includes("paraplegia") ||
    name.includes("dystonia") ||
    name.includes("charcot-marie-tooth") ||
    name.includes("spinal muscular")
  )
    return "Neurological";

  if (
    name.includes("muscular dystrophy") ||
    name.includes("myopathy") ||
    name.includes("myotonia") ||
    name.includes("osteogenesis imperfecta") ||
    name.includes("osteopetrosis") ||
    name.includes("skeletal") ||
    name.includes("bone") ||
    name.includes("arthrogryposis") ||
    name.includes("dysplasia")
  )
    return "Bone & muscle";

  if (
    name.includes("immunodeficiency") ||
    name.includes("severe combined") ||
    name.includes("neutropenia") ||
    name.includes("anemia") ||
    name.includes("thalassemia") ||
    name.includes("sickle cell") ||
    name.includes("hemophilia") ||
    name.includes("fanconi anemia")
  )
    return "Immune & blood";

  if (
    name.includes("cardiomyopathy") ||
    name.includes("polycystic kidney") ||
    name.includes("nephronophthisis") ||
    name.includes("alport") ||
    name.includes("nephrotic syndrome") ||
    name.includes("cystic fibrosis") ||
    name.includes("retinal") ||
    name.includes("retinitis pigmentosa") ||
    name.includes("hearing loss") ||
    name.includes("usher")
  )
    return "Single organ";

  if (
    name.includes("intellectual") ||
    name.includes("developmental delay") ||
    name.includes("syndrome")
  )
    return "Intellectual & other impacts";

  return "Other, rare";
};

const processAllConditions = () =>
  allConditionsRaw
    .trim()
    .split("\n")
    .map((line) => {
      const values = line.split(",");
      return {
        gene_name: values[0],
        condition_name: values[1],
        inheritance_pattern: normalizeInheritance(values[2]),
        category: categorizeCondition(values[1]),
      };
    });

const processCouplesConditions = () =>
  rawCouplesConditions.map((item) => ({
    condition_name: item.condition.replace("*", ""),
    gene_name: item.gene,
    inheritance_pattern: item.condition.includes("*")
      ? "X-linked"
      : "Autosomal recessive",
    category: categorizeCondition(item.condition),
  }));

const processCorePlusConditions = () =>
  rawCorePlusConditions.map((item) => ({
    condition_name: item.condition,
    gene_name: item.gene,
    inheritance_pattern: normalizeInheritance(item.inheritance),
    category: categorizeCondition(item.condition),
    carrier_frequency: item.carrierFreq,
  }));

const getCategoryStats = (conditions) =>
  conditions.reduce((acc, condition) => {
    const category = condition.category;
    if (!acc[category]) acc[category] = { count: 0, conditions: [] };
    acc[category].count++;
    acc[category].conditions.push(condition);
    return acc;
  }, {});

const allConditionsData = processAllConditions();
const couplesConditionsData = processCouplesConditions();
const corePlusConditionsData = processCorePlusConditions();

const data = {
  comprehensive: {
    stats: getCategoryStats(allConditionsData),
    total: 787,
    isComprehensive: true,
    title: "Comprehensive 787 Carrier Screening",
    description: "across 7 health impact categories",
  },
  couples: {
    stats: getCategoryStats(couplesConditionsData),
    total: couplesConditionsData.length,
    isComprehensive: false,
    title: "Couples Carrier Screening",
    description: "including the most common genetic conditions",
  },
  coreplus: {
    stats: getCategoryStats(corePlusConditionsData),
    total: corePlusConditionsData.length,
    isComprehensive: false,
    title: "Core Panel",
    description: "essential genetic conditions screening",
  },
};

const searchInput = document.getElementById("cpv-search-input");
const noResultsEl = document.getElementById("cpv-no-results");
const legendContainer = document.getElementById("cpv-legend");
const tabButtons = {
  coreplus: document.getElementById("cpv-tab-btn-coreplus"),
  couples: document.getElementById("cpv-tab-btn-couples"),
  comprehensive: document.getElementById("cpv-tab-btn-comprehensive"),
};
const tabContents = {
  coreplus: document.getElementById("cpv-tab-content-coreplus"),
  couples: document.getElementById("cpv-tab-content-couples"),
  comprehensive: document.getElementById("cpv-tab-content-comprehensive"),
};
const categoryContainers = {
  coreplus: document.getElementById("cpv-categories-container-coreplus"),
  couples: document.getElementById("cpv-categories-container-couples"),
  comprehensive: document.getElementById("cpv-categories-container-comprehensive"),
};
const cpvSection = document.getElementById("cpv-compare-charts");

const tableContainers = {
  coreplus: document.getElementById("cpv-table-container-coreplus"),
  couples: document.getElementById("cpv-table-container-couples"),
  comprehensive: document.getElementById("cpv-table-container-comprehensive"),
};
const cpvRootEl = document.querySelector("[data-cpv-root]");
  const cpvPdfBtn = document.querySelector(".cpv-pdf-download");
  const cpvPdfUrls = {
    coreplus: cpvRootEl?.dataset.cpvPdfCoreplus,
    couples: cpvRootEl?.dataset.cpvPdfCouples,
    comprehensive: cpvRootEl?.dataset.cpvPdfComprehensive,
  };
  const cpvPdfNames = {
    coreplus: "eugene-core-gene-list.pdf",
    couples: "eugene-couples-gene-list.pdf",
    comprehensive: "eugene-comprehensive-787-gene-list.pdf",
  };
  const cpvPdfLabels = {
    coreplus: "Download Core gene list",
    couples: "Download Couples gene list",
    comprehensive: "Download Comprehensive gene list",
  };
  const cpvPdfBtnLabel = cpvPdfBtn?.querySelector("span");
  function updatePdfDownload() {
    if (!cpvPdfBtn) return;
    const url = cpvPdfUrls[state.activeTab];
    if (url) {
      cpvPdfBtn.href = url;
      cpvPdfBtn.setAttribute("download", cpvPdfNames[state.activeTab] || "gene-list.pdf");
      if (cpvPdfBtnLabel) cpvPdfBtnLabel.textContent = cpvPdfLabels[state.activeTab] || "Download gene list";
      cpvPdfBtn.hidden = false;
    } else {
      cpvPdfBtn.hidden = true;
    }
  }
const defaultView = cpvRootEl?.dataset.cpvDefaultView === "category" ? "category" : "table";
state.viewMode = defaultView;
const viewControls = document.querySelector(".cpv-view-controls");
const viewButtons = viewControls ? Array.from(viewControls.querySelectorAll(".cpv-view-btn")) : [];

const cpvEnabled = {
  coreplus: cpvRootEl?.dataset.cpvShowCoreplus !== "false",
  couples: cpvRootEl?.dataset.cpvShowCouples !== "false",
  comprehensive: cpvRootEl?.dataset.cpvShowComprehensive !== "false",
};
const cpvTabsEnabled = cpvRootEl?.dataset.cpvShowTabs !== "false";
const cpvInitialTab = cpvRootEl?.dataset.cpvInitialTab;

(function initCpvActiveTab() {
  const order = ["comprehensive", "couples", "coreplus"];
  if (cpvInitialTab && cpvEnabled[cpvInitialTab]) {
    state.activeTab = cpvInitialTab;
  } else if (!cpvEnabled[state.activeTab]) {
    state.activeTab = order.find((t) => cpvEnabled[t]) || "comprehensive";
  }
})();

Object.keys(cpvEnabled).forEach((tab) => {
  if (cpvEnabled[tab]) return;
  tabButtons[tab]?.setAttribute("hidden", "");
  tabButtons[tab]?.style.setProperty("display", "none");
  tabContents[tab]?.setAttribute("hidden", "");
  tabContents[tab]?.style.setProperty("display", "none");
});

if (!cpvTabsEnabled) {
  const cpvTabsWrapper = document.querySelector(".cpv-tabs-nav-wrapper");
  if (cpvTabsWrapper) cpvTabsWrapper.style.display = "none";
}

const flatData = {
  coreplus: corePlusConditionsData,
  couples: couplesConditionsData,
  comprehensive: allConditionsData,
};

function normalizeInheritance(val) {
  const v = (val || "").toString().trim().toUpperCase();
  if (v === "XL" || v === "X-LINKED" || v === "X LINKED") return "X-linked";
  if (v === "AR" || v === "AUTOSOMAL RECESSIVE") return "Autosomal recessive";
  return val || "Autosomal recessive";
}

function formatConditionInfo(condition) {
  let conditionName = condition.condition_name.replace(/\*/g, "");
  let inheritancePattern = normalizeInheritance(condition.inheritance_pattern);

  const hasStar = condition.condition_name.includes("*");
  const isXLinked = hasStar || inheritancePattern === "X-linked";
  if (isXLinked) {
    conditionName = `${conditionName}*`;
    inheritancePattern = "X-linked";
  } else {
    inheritancePattern = "Autosomal recessive";
  }

  return { conditionName, inheritancePattern };
}

function setMobileFlag() {
  if (!cpvSection) return;
  cpvSection.classList.toggle("cpv-mobile-stack", isMobile());
}

function applyMobileBarHeights() {
  if (!isMobile()) return;

  document
    .querySelectorAll("#cpv-compare-charts .cpv-chart-bar-container")
    .forEach((container) => {
      const bar = container.querySelector(".cpv-chart-bar");
      if (!bar) return;

      const pctAttr = bar.getAttribute("data-totalpct");
      const m = (bar.getAttribute("style") || "").match(/width:\s*([\d.]+)%/i);
      const pct = pctAttr ? parseFloat(pctAttr) : m ? parseFloat(m[1]) : 0;

      const MAX_H = 180, MIN_H = 24;
      const h = Math.max(MIN_H, Math.round((pct / 100) * MAX_H));
      container.style.setProperty("--cpv-bar-height", h + "px");
    });
}
function orientSegmentsForMobile() {
  const mob = isMobile();

  document.querySelectorAll('#cpv-compare-charts .cpv-chart-bar').forEach((bar) => {
    if (!mob) {
      bar.style.removeProperty('flex-direction');
      bar.style.removeProperty('height');
      bar.querySelectorAll('.cpv-chart-segment').forEach((seg) => seg.style.removeProperty('height'));
      return;
    }

    bar.style.flexDirection = 'column-reverse';
    bar.style.height = '100%';

    const container = bar.closest('.cpv-chart-bar-container');
    const segs = Array.from(bar.querySelectorAll('.cpv-chart-segment'));
    if (!container || !segs.length) return;

    const cssVar = getComputedStyle(container).getPropertyValue('--cpv-bar-height');
    const baseline = cssVar ? parseFloat(cssVar) : 160;

    const pcts = segs.map((seg) => parseFloat(seg.dataset.pct || '0'));
    const intended = pcts.map((p) => (p / 100) * baseline);

    const DESIRED_MIN = 8;
    const maxMinPerSeg = Math.floor(baseline / segs.length) - 1;
    const minSegPx = Math.max(0, Math.min(DESIRED_MIN, isFinite(maxMinPerSeg) ? maxMinPerSeg : DESIRED_MIN));

    const floors = intended.map((h) => Math.max(minSegPx, Math.round(h)));
    let sumFloors = floors.reduce((a, b) => a + b, 0);

    if (sumFloors > baseline) {
      const aboveMin = floors.map((h) => h - minSegPx);
      const totalAbove = aboveMin.reduce((a, b) => a + b, 0);
      const excess = sumFloors - baseline;

      if (totalAbove > 0) {
        const scale = (totalAbove - excess) / totalAbove;
        for (let i = 0; i < floors.length; i++) {
          floors[i] = Math.round(minSegPx + aboveMin[i] * Math.max(0, scale));
        }
      } else {
        const even = Math.floor(baseline / floors.length);
        floors.fill(even);
      }
      sumFloors = floors.reduce((a, b) => a + b, 0);
    }

    const remaining = Math.max(0, Math.round(baseline - sumFloors));
    if (remaining > 0) {
      const headroom = intended.map((h, i) => Math.max(0, h - floors[i]));
      const totalHeadroom = headroom.reduce((a, b) => a + b, 0);

      if (totalHeadroom > 0) {
        const adds = headroom.map((h) => Math.floor((h / totalHeadroom) * remaining));
        let sumAdds = adds.reduce((a, b) => a + b, 0);

        if (adds.length) adds[adds.length - 1] += (remaining - sumAdds);

        for (let i = 0; i < floors.length; i++) {
          floors[i] += adds[i];
        }
      } else {
        floors[floors.length - 1] += remaining;
      }
    }

    segs.forEach((seg, i) => {
      seg.style.height = `${floors[i]}px`;
    });
  });
}

function renderAll() {
  renderCharts();
  renderTabs();
  renderLegend();
  updateAllCounts();
  enforceMinSegmentWidth(4);
}

function updateAllCounts() {
  Object.keys(data).forEach((panel) => {
    const total = data[panel].total;
    const countEl = document.getElementById(`cpv-count-${panel}`);
    if (countEl) countEl.textContent = total;
    const tabCountEl = document.querySelector(`.cpv-tab-count[data-panel="${panel}"]`);
    if (tabCountEl) tabCountEl.textContent = total;
  });
}

function renderLegend() {
  if (!legendContainer) return;
  legendContainer.innerHTML = legendCategoryOrder
    .map(
      (category) => `
    <div class="cpv-legend-item" data-category="${category}">
      <div
        class="cpv-legend-color-box"
        style="background-color: ${categoryColors[category]}"
        role="button"
        tabindex="0"
        aria-pressed="false"
        aria-label="Toggle ${category} highlight"
        data-category="${category}"
      >&nbsp;</div>
      <span class="cpv-legend-text">${category}</span>
    </div>
  `
    )
    .join("");
}

function renderCharts() {
  Object.keys(data).forEach((panel) => renderChart(panel, data[panel]));
}

function renderChart(panel, panelData) {
  const { stats, total, isComprehensive } = panelData;
  const container = document.getElementById(`cpv-chart-bar-${panel}`);
  if (!container) return;

  const displayTotal = isComprehensive ? 787 : total;
  if (displayTotal === 0) {
    container.innerHTML = "";
    return;
  }

  const chartCategoryOrder = legendCategoryOrder.filter(
    (cat) => stats[cat] && stats[cat].count > 0
  );
  const barTotalWidthPercent = (displayTotal / 787) * 100;

  const barHtml = chartCategoryOrder
    .map((category) => {
      const pct = (stats[category].count / displayTotal) * 100;
      return `<div class="cpv-chart-segment"
                  style="background-color:${categoryColors[category]}; width:${pct}%;"
                  data-category="${category}"
                  data-count="${stats[category].count}"
                  data-pct="${pct}">&nbsp;</div>`;
    })
    .join("");

  container.innerHTML = `<div class="cpv-chart-bar" data-totalpct="${barTotalWidthPercent}" style="width:${barTotalWidthPercent}%">${barHtml}</div>`;
}

function enforceMinSegmentWidth(minPx = 4) {
  document.querySelectorAll('#cpv-compare-charts .cpv-chart-bar').forEach(bar => {
    const barWidth = bar.getBoundingClientRect().width;
    if (!barWidth) return;

    const segs = Array.from(bar.querySelectorAll('.cpv-chart-segment'));
    if (!segs.length) return;

    const intended = segs.map(seg => (parseFloat(seg.dataset.pct || '0') / 100) * barWidth);

    const floored = intended.map(w => Math.max(minPx, Math.round(w)));
    const totalFloored = floored.reduce((a,b) => a + b, 0);
    const scale = totalFloored > 0 ? barWidth / totalFloored : 1;

    const finalPx = floored.map(w => Math.max(0, Math.floor(w * scale)));
    const drift = Math.round(barWidth - finalPx.reduce((a,b) => a + b, 0));
    if (finalPx.length) finalPx[finalPx.length - 1] += drift;

    segs.forEach((seg, i) => { seg.style.width = `${finalPx[i]}px`; });
  });
}

function renderTabs() {
  Object.keys(tabContents).forEach((tab) => {
    tabContents[tab].classList.toggle("active", state.activeTab === tab);
    tabButtons[tab].classList.toggle("active", state.activeTab === tab);
  });
  renderActiveView();
}

function renderActiveTabContent() {
  const panel = state.activeTab;
  const { stats } = data[panel];
  const openSet = state.openCategories[panel];
  const container = categoryContainers[panel];

  const filteredCategories = legendCategoryOrder.filter((category) => {
    const stat = stats[category];
    if (!stat || stat.count === 0) return false;
    if (!state.searchTerm) return true;
    const q = state.searchTerm.toLowerCase();
    return stat.conditions.some(
      (cond) =>
        cond.condition_name.toLowerCase().includes(q) ||
        cond.gene_name.toLowerCase().includes(q)
    );
  });

  if (filteredCategories.length === 0 && state.searchTerm) {
    container.innerHTML = "";
    noResultsEl.style.display = "block";
  } else {
    noResultsEl.style.display = "none";
    container.innerHTML = filteredCategories
      .map((category) => {
        const stat = stats[category];
        const isOpen = openSet.has(category);
        return renderCategorySection(
          category,
          stat,
          isOpen,
          panel === "coreplus"
        );
      })
      .join("");
  }
}

function formatConditionInfo(condition) {
  let conditionName = condition.condition_name.replace(/\*/g, "");
  let { inheritance_pattern: inheritancePattern } = condition;
  const isXLinked =
    inheritancePattern === "X-linked" || condition.condition_name.includes("*");
  if (isXLinked) {
    conditionName = `${conditionName}*`;
    inheritancePattern = "X-linked";
  }
  return { conditionName, inheritancePattern };
}

function renderCategorySection(category, stat, isOpen, isCorePlus) {
  const base = !state.searchTerm
    ? stat.conditions
    : stat.conditions.filter(
        (cond) =>
          cond.condition_name
            .toLowerCase()
            .includes(state.searchTerm.toLowerCase()) ||
          cond.gene_name.toLowerCase().includes(state.searchTerm.toLowerCase())
      );

  const displayCount = state.searchTerm ? base.length : stat.count;

  const conditionsHtml = (state.searchTerm ? base : base.slice(0, 50))
    .map((condition) => {
      const { conditionName, inheritancePattern } = formatConditionInfo(condition);
      const freqHtml =
        isCorePlus && condition.carrier_frequency
          ? `<div class="cpv-condition-info-right"><div>Carrier Freq.</div><div class="cpv-condition-freq">${condition.carrier_frequency}</div></div>`
          : "";
      return `<div class="cpv-condition-item">
        <div class="cpv-condition-info-left">
          <h4 class="cpv-condition-name">${conditionName}</h4>
          <div class="cpv-condition-details">
            <span>Gene: <span class="cpv-condition-gene">${condition.gene_name}</span></span>
            <span>Pattern: ${inheritancePattern}</span>
          </div>
        </div>
        ${freqHtml}
      </div>`;
    })
    .join("");

  const moreConditionsHtml =
    !state.searchTerm && stat.conditions.length > 50
      ? `<div class="cpv-conditions-more">... and ${
          stat.conditions.length - 50
        } more conditions</div>`
      : "";

  return `
    <div class="cpv-category-card">
      <button type="button" class="cpv-category-card-header" data-category="${category}" aria-expanded="${isOpen}">
        <div class="cpv-header-top-row">
          <div class="cpv-category-color-box" style="background-color: ${categoryColors[category]}"></div>
          <div class="cpv-header-main-content">
            <h3 class="cpv-category-title">${category}</h3>
            <p class="cpv-category-description">${categoryDescriptions[category]}</p>
          </div>
        </div>
        <div class="cpv-header-right-items">
          <span class="cpv-category-badge">${displayCount} condition${
            displayCount !== 1 ? "s" : ""
          }</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="cpv-chevron"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </div>
      </button>
      <div class="cpv-category-card-content ${isOpen ? "open" : ""}">${conditionsHtml}${moreConditionsHtml}</div>
    </div>`;
}

function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function getTableRows(panel) {
  const q = state.searchTerm.trim().toLowerCase();
  const rows = (flatData[panel] || []).filter((r) => {
    if (!q) return true;
    return (
      String(r.condition_name || "").toLowerCase().includes(q) ||
      String(r.gene_name || "").toLowerCase().includes(q)
    );
  });
  return rows.slice().sort((a, b) =>
    String(a.gene_name).localeCompare(String(b.gene_name))
  );
}

function renderTable(panel) {
  const container = tableContainers[panel];
  if (!container) return;

  const q = state.searchTerm.trim().toLowerCase();
  const rows = getTableRows(panel);

  if (rows.length === 0) {
    container.innerHTML = "";
    if (noResultsEl) noResultsEl.style.display = q ? "block" : "none";
    return;
  }
  if (noResultsEl) noResultsEl.style.display = "none";

  const collapsible = !q && rows.length > 6;
  const isCollapsed = collapsible && !state.tableExpanded;

  const body = rows
    .map((r) => {
      const isXLinked =
        normalizeInheritance(r.inheritance_pattern) === "X-linked" ||
        String(r.condition_name || "").includes("*");
      const conditionName = String(r.condition_name || "").replace(/\*/g, "");
      const inheritance = isXLinked ? "XL" : "AR";
      return `
        <tr>
          <td class="cpv-cell-gene">${escapeHtml(r.gene_name)}</td>
          <td class="cpv-cell-condition">${escapeHtml(conditionName)}</td>
          <td class="cpv-cell-inheritance">${inheritance}</td>
        </tr>`;
    })
    .join("");

  const chevron =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="cpv-chevron"><polyline points="6 9 12 15 18 9"></polyline></svg>';

  const headlineCount =
    data[panel] && typeof data[panel].total === "number" ? data[panel].total : rows.length;
  const fullBtn = collapsible
    ? `<button type="button" class="cpv-show-full" aria-expanded="${state.tableExpanded}">${
        state.tableExpanded ? "Show less" : "Show full " + headlineCount + " condition list"
      } ${chevron}</button>`
    : "";

  container.innerHTML = `
    <div class="cpv-table-wrap ${isCollapsed ? "is-collapsed" : ""}">
      <table class="cpv-gene-table">
        <thead><tr><th>Gene</th><th>Condition</th><th>Pattern</th></tr></thead>
        <tbody>${body}</tbody>
      </table>
    </div>
    ${fullBtn}
  `;
}

function updateViewControls() {
  viewButtons.forEach((btn) =>
    btn.classList.toggle("active", btn.dataset.view === state.viewMode)
  );
}

function renderActiveView() {
  const isTable = state.viewMode === "table";
  Object.keys(tabContents).forEach((p) => {
    if (categoryContainers[p]) categoryContainers[p].style.display = isTable ? "none" : "";
    if (tableContainers[p]) tableContainers[p].style.display = isTable ? "block" : "none";
  });

  const legendEl = document.querySelector(".cpv-x-linked-legend");
  if (legendEl) legendEl.style.display = isTable ? "" : "none";

  if (isTable) renderTable(state.activeTab);
  else renderActiveTabContent();

  updateViewControls();
}

function handleViewToggle(e) {
  const btn = e.target.closest(".cpv-view-btn");
  if (!btn) return;
  const view = btn.dataset.view;
  if (!view || view === state.viewMode) return;
  state.viewMode = view;
  state.tableExpanded = false;
  renderActiveView();
}

function handleShowFull(e) {
  const btn = e.target.closest(".cpv-show-full");
  if (!btn) return;
  state.tableExpanded = !state.tableExpanded;
  renderActiveView();
}

function handleTabClick(e) {
  const tab = e.target.closest(".cpv-tab-button")?.dataset.tab;
  if (tab && tab !== state.activeTab) {
    state.activeTab = tab;
    renderTabs();
    updatePdfDownload();
  }
}

function handleSearchInput(e) {
  state.searchTerm = e.target.value;
  renderActiveView();
}

function handleCategoryToggle(e) {
  const header = e.target.closest(".cpv-category-card-header");
  if (!header) return;
  const category = header.dataset.category;
  const openSet = state.openCategories[state.activeTab];
  if (openSet.has(category)) openSet.delete(category);
  else openSet.add(category);
  renderActiveTabContent();
}

function handleChartHover(e) {
  if (isMobile()) return;
  const segment = e.target.closest(".cpv-chart-segment");
  if (!segment) return;

  const category = segment.dataset.category;
  clearCategoryHighlight();
  setCategoryHighlight(category);

  document
    .querySelectorAll("#cpv-legend .cpv-legend-item")
    .forEach((item) =>
      item.classList.toggle("hover", item.dataset.category === category)
    );
}

function clearCategoryHighlight() {
  const root = document.querySelector(".cpv-all-charts-container");
  root?.classList.remove("is-highlighting");

  document
    .querySelectorAll(".cpv-chart-segment.is-active")
    .forEach((el) => el.classList.remove("is-active", "segment-hovered"));
  document
    .querySelectorAll(".cpv-legend-item.active")
    .forEach((el) => el.classList.remove("active"));

  document
    .querySelectorAll(".cpv-chart-tooltip.visible")
    .forEach((t) => t.classList.remove("visible"));
}

let activeCategory = null;

function setActiveCategory(nextCategory) {
  clearCategoryHighlight();
  document
    .querySelectorAll("#cpv-legend .cpv-legend-item")
    .forEach((i) => i.classList.remove("active"));
  document
    .querySelectorAll("#cpv-legend .cpv-legend-color-box")
    .forEach((b) => b.setAttribute("aria-pressed", "false"));

  if (!nextCategory) {
    activeCategory = null;
    return;
  }
  activeCategory = nextCategory;

  const item = document.querySelector(
    `#cpv-legend .cpv-legend-item[data-category="${nextCategory}"]`
  );
  if (item) {
    item.classList.add("active");
    const box = item.querySelector(".cpv-legend-color-box");
    if (box) box.setAttribute("aria-pressed", "true");
  }

  setCategoryHighlight(nextCategory);
}

function handleLegendClick(e) {
  const item = e.target.closest(".cpv-legend-item");
  if (!item) return;
  const category = item.dataset.category;
  setActiveCategory(activeCategory === category ? null : category);
}

function handleChartTap(e) {
  if (!isMobile()) return;
  const seg = e.target.closest(".cpv-chart-segment");
  if (!seg) return;
  const category = seg.dataset.category;
  setActiveCategory(activeCategory === category ? null : category);
}

function setCategoryHighlight(category) {
  const root = document.querySelector(".cpv-all-charts-container");
  if (!root) return;
  root.classList.add("is-highlighting");

  document
    .querySelectorAll(`.cpv-chart-segment[data-category="${category}"]`)
    .forEach((seg) => seg.classList.add("is-active", "segment-hovered"));

  document.querySelectorAll(".cpv-chart-wrapper").forEach((wrapper) => {
    const seg = wrapper.querySelector(
      `.cpv-chart-segment[data-category="${category}"]`
    );

    let tooltip = wrapper.querySelector(".cpv-chart-tooltip");
    if (!tooltip) {
      tooltip = document.createElement("div");
      tooltip.className = "cpv-chart-tooltip";
      wrapper.appendChild(tooltip);
    }

    const bar = wrapper.querySelector(".cpv-chart-bar");
    if (!bar) return;

    const wrapRect = wrapper.getBoundingClientRect();
    let left;

    if (seg) {
      const segRect = seg.getBoundingClientRect();
      left = segRect.left - wrapRect.left;

      const count = seg.dataset.count;
      tooltip.innerHTML = `
        <p class="cpv-tooltip-category">${category}</p>
        <p class="cpv-tooltip-count">~ ${count} condition${count === "1" ? "" : "s"}</p>
      `;
      tooltip.classList.remove("cpv-tooltip-empty");
    } else {
      const barRect = bar.getBoundingClientRect();
      left = (barRect.right - wrapRect.left) - 1;

      tooltip.innerHTML = `
        <p class="cpv-tooltip-category">${category}</p>
        <p class="cpv-tooltip-count">Not included</p>
      `;
      tooltip.classList.add("cpv-tooltip-empty");
    }

    const wrapW = wrapRect.width;
    if (isMobile()) {
      tooltip.style.whiteSpace = "normal";
      tooltip.style.maxWidth = Math.max(0, wrapW - 16) + "px";
      requestAnimationFrame(() => {
        const ttW = tooltip.offsetWidth || 0;
        const clampedLeft = Math.min(Math.max(left, 8), Math.max(8, wrapW - ttW - 8));
        tooltip.style.left = clampedLeft + "px";
        tooltip.style.transform = "translateX(0)";
        tooltip.classList.add("visible");
      });
    } else {
      tooltip.style.removeProperty("max-width");
      tooltip.style.whiteSpace = "";
      tooltip.style.width = "auto";

      tooltip.style.left = left + "px";
      tooltip.style.transform = "translateX(0)";
      tooltip.classList.add("visible");
    }
  });
}

function handleChartMouseOut(e) {
  const leavingSeg = e.target.closest(".cpv-chart-segment");
  if (!leavingSeg) return;

  const hasActiveLegend = !!document.querySelector(
    "#cpv-legend .cpv-legend-item.active"
  );
  if (!hasActiveLegend) {
    clearCategoryHighlight();
    document
      .querySelectorAll("#cpv-legend .cpv-legend-item.hover")
      .forEach((i) => i.classList.remove("hover"));
  }
}

function handleAboutToggle(e) {
  const trigger = e.target.closest(".cpv-collapsible-trigger");
  if (!trigger) return;
  const content = trigger.nextElementSibling;
  const isExpanded = trigger.getAttribute("aria-expanded") === "true";
  trigger.setAttribute("aria-expanded", !isExpanded);
  content.classList.toggle("open");
}

setMobileFlag();

const _renderAll = renderAll;
renderAll = function () {
  _renderAll();
  setMobileFlag();
  applyMobileBarHeights();
  orientSegmentsForMobile();
  enforceMinSegmentWidth(4);
};

let _rz;
window.addEventListener("resize", () => {
  clearTimeout(_rz);
  _rz = setTimeout(() => {
    setMobileFlag();
    applyMobileBarHeights();
    orientSegmentsForMobile();
    enforceMinSegmentWidth(4);
  }, 120);
});

document.querySelector(".cpv-tabs-nav-container")?.addEventListener("click", handleTabClick);
searchInput?.addEventListener("input", handleSearchInput);
document.querySelector(".cpv-tabs-content-wrapper")?.addEventListener("click", handleCategoryToggle);
document.querySelector(".cpv-tabs-content-wrapper")?.addEventListener("click", handleShowFull);
viewControls?.addEventListener("click", handleViewToggle);
document.querySelector(".cpv-about-container")?.addEventListener("click", handleAboutToggle);

const chartsRoot = document.querySelector(".cpv-all-charts-container");
chartsRoot?.addEventListener("mouseover", handleChartHover);
chartsRoot?.addEventListener("mouseout", handleChartMouseOut);
chartsRoot?.addEventListener("click", handleChartTap);

legendContainer?.addEventListener("click", handleLegendClick);
legendContainer?.addEventListener("keydown", (e) => {
  if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
  if (!e.target.closest(".cpv-legend-color-box")) return;
  e.preventDefault();
  handleLegendClick(e);
});

renderAll();
updatePdfDownload();

document.addEventListener("click", (e) => {
  const inLegend = e.target.closest("#cpv-legend");
  const inCharts = e.target.closest(".cpv-all-charts-container");
  if (!inLegend && !inCharts) setActiveCategory(null);
});

})
